import React, { useState } from 'react';
import { Modal, Button, Form, Card, Badge } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';

function ConnectorModal({ show, onHide, availableConnectors, runbookConnectors, onAddConnector, onRemoveConnector }) {
  const [selectedConnectorId, setSelectedConnectorId] = useState('');

  const handleAddConnector = () => {
    if (selectedConnectorId) {
      const connector = availableConnectors.find(c => c.connectorId === selectedConnectorId);
      if (connector) {
        onAddConnector(connector);
        setSelectedConnectorId('');
      }
    }
  };

  // Filter out connectors already added to the runbook
  const availableToAdd = availableConnectors.filter(
    ac => !runbookConnectors.find(rc => rc.connectorId === ac.connectorId)
  );

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Manage Runbook Connectors</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Currently Added Connectors */}
        {runbookConnectors.length > 0 && (
          <div className="mb-4">
            <h6 className="small fw-bold mb-2">Added to Runbook</h6>
            {runbookConnectors.map((connector) => (
              <Card key={connector.connectorId} className="mb-2 border">
                <Card.Body className="p-2 d-flex justify-content-between align-items-center">
                  <div>
                    <div className="fw-bold small">{connector.connectorNumber} - {connector.description}</div>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                      ID: {connector.connectorId} | System: {connector.system}
                    </div>
                  </div>
                  <Button
                    variant="link"
                    size="sm"
                    className="text-danger p-0"
                    onClick={() => onRemoveConnector(connector.connectorId)}
                  >
                    <FaTrash />
                  </Button>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}

        {/* Add Connector Section */}
        <div>
          <h6 className="small fw-bold mb-2">Add Connector to Runbook</h6>
          {availableToAdd.length > 0 ? (
            <>
              <Form.Group className="mb-3">
                <Form.Select
                  size="sm"
                  value={selectedConnectorId}
                  onChange={(e) => setSelectedConnectorId(e.target.value)}
                >
                  <option value="">Select a connector...</option>
                  {availableToAdd.map((connector) => (
                    <option key={connector.connectorId} value={connector.connectorId}>
                      {connector.connectorNumber} - {connector.description} ({connector.system})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Button
                variant="primary"
                size="sm"
                className="w-100"
                onClick={handleAddConnector}
                disabled={!selectedConnectorId}
              >
                <FaPlus className="me-1" /> Add to Runbook
              </Button>
            </>
          ) : (
            <div className="text-muted small text-center py-3">
              {availableConnectors.length === 0
                ? "No connectors available. Please create connectors in My Connectors first."
                : "All available connectors have been added to this runbook."}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConnectorModal;
